<!-- Old CIEP Page -->

<!-- <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
  <div  class="c-container">

    <div class="c-login-logo">
      <img [src]="logoURL ? logoURL : 'assets/images/logo-brand-pmc.svg'" />
    </div>
    <div class="c-status-message">
      <p
        *ngIf="isGrayShowErrMsg$ | async"
        class="u-background-color-neutral u-font-color-white u-padding-10 u-text-center"
      >
        {{ errorMessages$ |async}}
      </p>
      <p
        *ngIf="isRedShowErrMsg$ | async"
        class="u-background-color-error u-font-color-white u-padding-10 u-text-center"
      >
        {{ errorMessages$ |async}}
      </p>
    </div>
    <div class="c-login-box">
      <mat-form-field class="mat-block" appearance="fill" *ngIf="!isdomainList">
        <mat-icon matPrefix>person</mat-icon>
        <input
          matInput
          [placeholder]="'login.login_form.user_name' | translate"
          formControlName="username"
          required
          value=""
          (keydown)="noWhiteSpaceAllow($event)"
        />
        <mat-error class="error-message" *ngIf="hasError('username','required')">
          {{ "login.login_form.user_name_validation" | translate }}
        </mat-error>
        <mat-error
          class="error-message"
          *ngIf="
                  (loginForm.get('username').dirty ||
                  loginForm.get('username').touched ) &&
                  loginForm.get('username').hasError('pattern')
                "
        >
          {{ "login.login_form.invalid_character_validation" | translate }}
        </mat-error>
      </mat-form-field>
      <mat-form-field
        class="mat-block"
        appearance="fill"
        *ngIf="isdomainList"
        style="width:49%; margin-right: 2%;"
      >
        <mat-icon matPrefix>person</mat-icon>
        <input
          matInput
          [placeholder]="'login.login_form.user_name' | translate"
          formControlName="username"
          required
          value=""
          (keydown)="noWhiteSpaceAllow($event)"
        />
        <mat-error class="error-message" *ngIf="hasError('username','required')">
          {{ "login.login_form.user_name_validation" | translate }}
        </mat-error>
        <mat-error
          class="error-message"
          *ngIf="
                  (loginForm.get('username').dirty ||
                  loginForm.get('username').touched ) &&
                  loginForm.get('username').hasError('pattern')
                "
        >
          {{ "login.login_form.invalid_character_validation" | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="mat-block" appearance="fill" *ngIf="isdomainList" style="width:49%">
        <mat-select
          formControlName="domainName"
          id="ebasketMethod"
          [placeholder]="
      'login.login_form.selectDomain' |
      translate"
        >
          <mat-option value="">Default Domain</mat-option>
          <mat-option *ngFor="let domain of domainList" [value]="domain.domainName">
            @{{domain.domainName}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="mat-block" appearance="fill">
        <mat-icon matPrefix>vpn_key</mat-icon>
        <input
          matInput
          [placeholder]="'login.login_form.password' | translate"
          value=""
          (keydown)="noWhiteSpaceAllow($event)"
          [type]="hide ? 'text' : 'password'"
          formControlName="password"
          required
        />
        <mat-icon matSuffix (click)="hide = !hide"
          >{{hide ? 'visibility' : 'visibility_off'}}</mat-icon
        >
        <mat-error class="error-message" *ngIf="hasError('password','required')">
          {{ "login.login_form.password_validation" | translate }}
        </mat-error>
      </mat-form-field>

      <div class="u-margin-bottom-15 u-font-size-12">
        <a href="forgot-password">{{ "login.login_form.forgot_password" | translate }}</a>
      </div>

      <mat-error class="error-message" *ngIf="invalideUserDetails">
        {{"login.login_form.invalid_credentials" | translate}}
      </mat-error>
      <button mat-button mat-flat-button color="primary">Login</button>
    </div>
  </div>
</form> -->

<!-- New Graphene Page -->

<form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
  <div
    class="c-container c-container-position-{{getLoginBoxPosition(isLargeScreen?DEVICE_TYPE.LANDSCAPE:DEVICE_TYPE.PORTRAIT)}}"
  >
    <video
      autoplay
      [muted]="'muted'"
      loop
      id="graphenethemebg"
      *ngIf="isGlobalPortal || !landscapeBGImage || !portraitBGImage"
    >
      <source
        src="https://ciep-om-essential-dev-images-eu-west-1.s3.eu-west-1.amazonaws.com/video/pmc-org/05+Globle+BG.mp4"
        type="video/mp4"
      />
    </video>
    <div
      *ngIf="!isGlobalPortal && (landscapeBGImage || portraitBGImage)"
      [ngStyle]="{
        'background-image': isLargeScreen ? 'url(' + getBackgroundImage('landscape') + ')' : 'url(' + getBackgroundImage('portrait') + ')'}"
      class="bg-image"
    ></div>

    <div class="c-content">
      <!-- Logo For global portal login  -->

      <div class="c-graphene-logo" *ngIf="!logoURL">
        <img src="assets/images/Graphenelogo.svg" width="300px" />
      </div>

      <div class="c-form">
        <!-- Logo For organization login  -->
        <div class="c-customer-logo">
          <div class="c-logo" *ngIf="logoURL">
            <img [src]="logoURL ? logoURL : ''" width="80px" />
          </div>
        </div>
        <div class="c-fields">
          <div>
            <mat-form-field class="mat-block" appearance="outline" *ngIf="isdomainList">
              <mat-label>Domain</mat-label>
              <mat-select
                formControlName="domainName"
                id="ebasketMethod"
                [placeholder]="'login.login_form.selectDomain' | translate"
              >
                <mat-option *ngFor="let domain of domainList" [value]="domain.domainName">
                  &#64;{{domain.domainName}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field class="mat-block" appearance="outline" *ngIf="!isdomainList">
              <mat-label>Username</mat-label>
              <input
                matInput
                [placeholder]="'login.login_form.user_name' | translate"
                formControlName="username"
                required
                value=""
                (keydown)="noWhiteSpaceAllow($event)"
              />
              <mat-error
                class="c-hint-error-note u-font-color-error"
                *ngIf="hasError('username','required')"
              >
                {{ "login.login_form.user_name_validation" | translate }}
              </mat-error>
              <mat-error
                class="c-hint-error-note u-font-color-error"
                *ngIf="
                          (loginForm.get('username').dirty ||
                          loginForm.get('username').touched ) &&
                          loginForm.get('username').hasError('pattern')
                        "
              >
                {{ "login.login_form.invalid_character_validation" | translate }}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-block" appearance="outline" *ngIf="isdomainList">
              <mat-label>Username</mat-label>
              <input
                matInput
                [placeholder]="'login.login_form.user_name' | translate"
                formControlName="username"
                required
                value=""
                (keydown)="noWhiteSpaceAllow($event)"
              />
              <mat-error
                class="c-hint-error-note u-font-color-error"
                *ngIf="hasError('username','required')"
              >
                {{ "login.login_form.user_name_validation" | translate }}
              </mat-error>
              <mat-error
                class="c-hint-error-note u-font-color-error"
                *ngIf="
                          (loginForm.get('username').dirty ||
                          loginForm.get('username').touched ) &&
                          loginForm.get('username').hasError('pattern')
                        "
              >
                {{ "login.login_form.invalid_character_validation" | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <!-- <div class="c-hint-error-note u-font-color-error">
              Error: Enter correct username
            </div> -->

          <div class="c-password-field">
            <mat-form-field class="mat-block" appearance="outline">
              <mat-label>Password</mat-label>
              <input
                matInput
                [placeholder]="'login.login_form.password' | translate"
                value=""
                (keydown)="noWhiteSpaceAllow($event)"
                [type]="hide ? 'text' : 'password'"
                formControlName="password"
                required
              />
              <mat-icon matSuffix (click)="hide = !hide"
                >{{hide ? 'visibility' : 'visibility_off'}}</mat-icon
              >
              <mat-error
                class="c-hint-error-note u-font-color-error"
                *ngIf="hasError('password','required')"
              >
                {{ "login.login_form.password_validation" | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="c-forgot-password">
            <a href="forgot-password">{{ "login.login_form.forgot_password" | translate }}</a>
          </div>
          <div class="c-status-message">
            <p *ngIf="isGrayShowErrMsg$ | async" class=" u-text-center">
              {{ errorMessages$ |async}}
            </p>
            <p *ngIf="isRedShowErrMsg$ | async" class=" u-text-center">
              {{ errorMessages$ |async}}
            </p>
          </div>

          <mat-error
            class="c-hint-error-note-invalid u-font-color-error"
            *ngIf="invalideUserDetails"
          >
            {{"login.login_form.invalid_credentials" | translate}}
          </mat-error>
          <div>
            <button mat-raised-button color="primary">Login</button>
          </div>
        </div>
        <!--Logo For Organization Login -->
        <div class="c-powered-by" *ngIf="logoURL">
          <img src="assets/images/Poweredbygraphene.svg" width="80px" />
        </div>
      </div>
    </div>
  </div>
</form>
